import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../components/api/axiosInstance";
import WebsiteLeadsPanel from "../components/WebsiteLeadsPanel";
import WebsiteFormKeys from "../components/WebsiteFormKeys";

async function loadLeadStatuses() {
  const res = await axiosInstance.get("/lead-statuses");
  return Array.isArray(res.data) ? res.data : res.data?.data || [];
}

const TABS = [
  { id: "leads", label: "Leads" },
  { id: "keys", label: "Form Keys" },
];

function WebsiteLeads() {
  const navigate = useNavigate();
  const [tab, setTab] = useState("leads");
  return (
    <div className="p-2 p-md-3 wl-page">
      <div className="wl-page-select-wrap">
        <select
          className="wl-page-select"
          value={tab}
          onChange={(e) => setTab(e.target.value)}
          aria-label="Website leads section"
        >
          {TABS.map((t) => (
            <option key={t.id} value={t.id}>
              {t.label}
            </option>
          ))}
        </select>
      </div>
      <div className="wl-page-tabs" role="tablist" aria-label="Website leads sections">
        {TABS.map((t) => (
          <button
            key={t.id}
            type="button"
            role="tab"
            aria-selected={tab === t.id}
            className={`wl-page-tab${tab === t.id ? " is-active" : ""}`}
            onClick={() => setTab(t.id)}
          >
            {t.label}
          </button>
        ))}
      </div>
      {tab === "leads" ? (
        <WebsiteLeadsPanel
          apiBase="/website-leads"
          loadStatuses={loadLeadStatuses}
          showTenant
          onOpenLead={(leadId) => navigate(`/realestate-leads/${leadId}/view`)}
        />
      ) : (
        <WebsiteFormKeys />
      )}
    </div>
  );
}

export default WebsiteLeads;
